export const UPDATE_PRESENCE_TABLE_PAGE = () => `/update-presence`;
